<script lang="ts">
	//UI
	import DailyReport from "./views/DailyReport.svelte";
	import Atu from "./views/Atu.svelte";
	import Error from "./views/Error.svelte";
	//Utils
	import { Router, Route } from "svelte-routing";
	//Types
	//Props
	//Constants
	//Variables
	//Functions
	function getToken(search: string) {
		const params = new URLSearchParams(search);
		return params.get("token");
	}
	//Do
</script>

<Router>
	<Route path="/daily" let:location>
		<DailyReport token={getToken(window.location.search)} />
	</Route>
	<Route path="/atu" let:location>
		<Atu token={getToken(window.location.search)} />
	</Route>
	<Route path="/error">
		<Error />
	</Route>
	<!-- Will Be Deprecated -->
	<Route path="/*">
		<Router>
			<Route path="/:token" let:params>
				<DailyReport token={params.token} />
			</Route>
		</Router>
	</Route>
</Router>

<!--  -->
<style lang="scss">
</style>
